import React from 'react'
import ReactDOM from 'react-dom'
import { AppContainer } from 'react-hot-loader'
import Main from './components/main/Main'
import './entry'
import './lib/polyfill.object'
import './styles/layout.less'
import './styles/landing.less'

if (navigator.standalone) {
	location.replace('/polls')
}

ReactDOM.render(
	<AppContainer>
		<Main />
	</AppContainer>,
	document.getElementById('root')
)

if (module.hot) {
	module.hot.accept('./components/main/Main', () => {
		// eslint-disable-next-line global-require
		const NewRoot = require('./components/main/Main').default
		ReactDOM.render(
			<AppContainer>
				<NewRoot />
			</AppContainer>,
			document.getElementById('root')
		)
	})
}



// WEBPACK FOOTER //
// ./src/entry.landing.jsx